import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import classNames from 'classnames/bind';
import { Text } from '@carnica/ui-kit';
import { connector } from "./connector";
import styles from "./styles.pcss";
import { InputForm } from "./InputForm/InputForm";
import { SuccessForm } from "./SuccessForm/SuccessForm";
var cx = classNames.bind(styles);
export var _SubscriptionForm = function _SubscriptionForm(_ref) {
  var thankYou = _ref.thankYou,
    subscribe = _ref.subscribe,
    formIcon = _ref.formIcon,
    onClick = _ref.onClick,
    theme = _ref.theme;
  var _useState = useState('fill'),
    _useState2 = _slicedToArray(_useState, 2),
    requestStatus = _useState2[0],
    setRequestStatus = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    email = _useState4[0],
    setEmail = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    animate = _useState6[0],
    setAnimate = _useState6[1];
  var iconRef = useRef(null);
  var _useState7 = useState(true),
    _useState8 = _slicedToArray(_useState7, 2),
    agreeRules = _useState8[0],
    setAgreeRules = _useState8[1];
  var resetForm = function resetForm() {
    setRequestStatus('fill');
    setEmail('');
  };
  return /*#__PURE__*/React.createElement("div", {
    className: cx('wrapper', "theme-".concat(theme)),
    "data-t-id": "components-SubscriptionForms"
  }, /*#__PURE__*/React.createElement(Text, {
    transform: "lowercase",
    variant: "body-medium"
  }, requestStatus === 'success' ? thankYou : subscribe), requestStatus === 'success' ? /*#__PURE__*/React.createElement(SuccessForm, {
    resetForm: resetForm
  }) : /*#__PURE__*/React.createElement(InputForm, {
    agreeRules: agreeRules,
    animate: animate,
    email: email,
    iconRef: iconRef,
    onClick: onClick,
    requestStatus: requestStatus,
    setAgreeRules: setAgreeRules,
    setAnimate: setAnimate,
    setEmail: setEmail,
    setRequestStatus: setRequestStatus
  }), /*#__PURE__*/React.createElement("img", {
    alt: "",
    className: cx('wrapper__icon', animate && 'wrapper__icon-animate'),
    loading: "lazy",
    ref: iconRef,
    src: formIcon
  }));
};
export var SubscriptionForm = connector(_SubscriptionForm);